import { rootStore } from '@store/rootStore/instanse'
import { SETTING_NAME, BACKGROUND_MAP, DEFAULT_BACKGROUND_ID } from '../constants'
import { apiRequest } from '@utils/apiRequest'
import { toNumberIfDigits } from '@utils/toNumberIfDigits'

export const useBackgroundStyle = () => {
    const backgroundId = toNumberIfDigits(rootStore.currentUserStore.getSettingOption(SETTING_NAME), DEFAULT_BACKGROUND_ID)
    const backgroundStyle = BACKGROUND_MAP.find(item => item.id === backgroundId)?.value

    const setBackgroundId = (newBackgroundId: number) => {
        rootStore.currentUserStore.setSettingOption(SETTING_NAME, newBackgroundId)

        apiRequest(async (api, crmId) => {
            await api.setUserSettings({
                crm_id: crmId,
                name: SETTING_NAME,
                value: newBackgroundId.toString(),
            })
        })
    }
    
    return {
        backgroundId,
        backgroundStyle,
        setBackgroundId,
    }
}